import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { QuoteTypeService } from '../../services/quote-type/quote-type.service';
import { AuthenticationService } from 'src/app/modules/authentication/authentication.service';

@Injectable()
export class QuoteTypeResolver implements Resolve<{[key: string]: string}[]> {
    constructor(
      private quoteTypeService: QuoteTypeService,
      private authenticationService: AuthenticationService
    ){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<{[key: string]: string}[]> {
    const routeDealerId = route.queryParamMap.get('dealership_id') || route.paramMap.get('dealership_id');
    const currentDealerId = this.authenticationService.currentMfrProgram?.dealer_id;
    return this.quoteTypeService.getQuoteTypes(routeDealerId || currentDealerId);
  }
}
